"use client";
import {useRouter, usePathname} from "next/navigation";
import {Heading, Stack, Text} from "@chakra-ui/react";
import {HEADING_VARIANTS} from "@/theme/components/heading";
import {scrollToElement} from "@/utils/scrollToElement";
import {FOOTER_CONSTANTS, POLICIES_OPTION} from "../footer.constants";

const FooterPolicies = () => {
  const router = useRouter();
  const pathname = usePathname();

  const handleClick = (servicePath: string) => {
    const [basePath, hash] = servicePath.split("#");

    if (pathname === basePath && hash) {
      scrollToElement(hash, 120);
    } else {
      router.push(servicePath);
    }
  };

  return (
    <Stack spacing={6} color="white">
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>{FOOTER_CONSTANTS.POLICIES}</Heading>
      <Stack>
        {POLICIES_OPTION.map((service) => (
          <Text
            key={service.path}
            cursor="pointer"
            _hover={{textDecor: "underline"}}
            onClick={() => handleClick(service.path)}
          >
            {service.name}
          </Text>
        ))}
      </Stack>
    </Stack>
  );
};

export default FooterPolicies;
